import './ParkingNotice.css';

const ParkingNotice = () => {
  return <h1 className='parking_notice'>This domain is parked.</h1>;
};

export default ParkingNotice;
